import { type InterfaceEntity, SecurityType } from '@unifyapps/defs/types/interface';
import type { StoreApi, UseBoundStore } from 'zustand';
import InterfaceHelper from '../helper/InterfaceHelper';

export const getInterfaceRecordSelectors = (
  store: UseBoundStore<
    StoreApi<{
      interfaceRecord: InterfaceEntity;
      parentInterfaceRecord?: InterfaceEntity;
    }>
  >,
) => {
  return {
    useId: () => store((state) => state.interfaceRecord.id),
    useName: () => store((state) => state.interfaceRecord.properties.name),
    useType: () => store((state) => state.interfaceRecord.properties.type),
    useDetails: () => store((state) => state.interfaceRecord),
    useMetadata: () => store((state) => state.interfaceRecord.properties.metadata),
    useManifest: () => store((state) => state.interfaceRecord.properties.manifest),
    useApplicationType: () => store((state) => state.interfaceRecord.properties.manifest?.type),
    useFlags: () => store((state) => state.interfaceRecord.properties.flags),
    useNavigation: () => store((state) => state.interfaceRecord.properties.navigation),
    usePaths: () => store((state) => state.interfaceRecord.properties.paths),
    usePageTransition: () =>
      store((state) => state.interfaceRecord.properties.navigation.pageTransition),
    useDefaultPageId: () =>
      store((state) => state.interfaceRecord.properties.navigation.defaultPageId),
    useTheme: () => store((state) => state.interfaceRecord.properties.theme),
    useDeviceDetails: () => store((state) => state.interfaceRecord.properties.deviceDetails),
    useInterfacePageIdVsSlugMap: () =>
      store((state) => InterfaceHelper.getInterfacePageIdVsSlugMap(state.interfaceRecord)),
    useDisplayDetails: () =>
      store((state) => state.interfaceRecord.properties.manifest?.displayDetails),
    useMqttTopics: () => store((state) => state.interfaceRecord.properties.mqttTopics),
    useCustomEvents: () => store((state) => state.interfaceRecord.properties.customEvents),
    useAppVariants: () => store((state) => state.interfaceRecord.properties.appVariants),
    useSecurity: () =>
      store(
        (state) =>
          state.interfaceRecord.properties.package?.security ??
          state.interfaceRecord.properties.security,
      ),
    useIsPublic: () =>
      store((state) =>
        state.interfaceRecord.properties.parentInterfaceId
          ? state.parentInterfaceRecord?.properties.security?.type === SecurityType.Public
          : state.interfaceRecord.properties.security?.type === SecurityType.Public,
      ),
  };
};
